<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { getValue } from 'felte';

	export let label: string;
	export let placeholder: string | undefined = undefined;
	export let value: string | number | undefined | null;
	export let isInvalide: string = '';
	export let disabled: boolean | undefined = void 0;
	export let id: string = '';
	// felter implementation
	export let felteErrors: any | undefined = undefined;
	export let felteProp: string | undefined = undefined;
	export let autocomplete: string | undefined = undefined;

	// todo: remove when ready, bypass code checking for now
	id;

	const dispatch = createEventDispatcher();
	function handleChange(event: any) {
		const newValue = event.target.value;
		dispatch('input', newValue);
		// this for 2-way binding
		value = newValue;
	}

	let showPassword: boolean = false;
	let showConfirmPassword: boolean = false;

	$: felteErrorMsg =
		felteErrors &&
		felteProp &&
		getValue(felteErrors, felteProp) &&
		getValue(felteErrors, felteProp)?.[0];
</script>

<div class="flex flex-col gap-[6px] relative">
	<label for={label} class="">{label.toLocaleUpperCase()}</label>
	{#if label === 'Password*'}
		{#if showPassword}
			<input
				class="border-[#DDD] w-full relative z-[0] pr-8 focus:outline-none focus:border-affair {felteErrorMsg
					? '!border-red'
					: ''}"
				style={isInvalide}
				bind:value
				on:input={handleChange}
				id={label}
				type="text"
				{placeholder}
				{autocomplete}
			/>
		{:else}
			<input
				class="border-[#DDD] w-full relative z-[0] pr-8 focus:outline-none focus:border-affair {felteErrorMsg
					? '!border-red'
					: ''}"
				style={isInvalide}
				bind:value
				on:input={handleChange}
				id={label}
				type="password"
				{placeholder}
				{autocomplete}
			/>
		{/if}
		<button
			tabindex="-1"
			type="button"
			on:click={(event) => (event.stopPropagation(), (showPassword = !showPassword))}
		>
			{#if !showPassword}
				<img
					class="absolute right-2 top-[40px] z-[1] cursor-pointer"
					src="/icons/eye.svg"
					alt="eye"
				/>
			{:else}
				<img
					class="absolute right-2 top-[40px] z-[1] cursor-pointer"
					src="/icons/eye-slash.svg"
					alt="eye"
				/>
			{/if}
		</button>
	{:else if label === 'Confirm password*'}
		{#if showConfirmPassword}
			<input
				class="border-[#DDD] w-full relative z-[0] pr-8 focus:outline-none focus:border-affair {felteErrorMsg
					? '!border-red'
					: ''}"
				style={isInvalide}
				bind:value
				on:input={handleChange}
				id={label}
				type="text"
				{placeholder}
				{autocomplete}
			/>
		{:else}
			<input
				class="border-[#DDD] w-full relative z-[0] pr-8 focus:outline-none focus:border-affair {felteErrorMsg
					? '!border-red'
					: ''}"
				style={isInvalide}
				bind:value
				on:input={handleChange}
				id={label}
				type="password"
				{placeholder}
				{autocomplete}
			/>
		{/if}
		<button
			type="button"
			on:click={(event) => (event.stopPropagation(), (showConfirmPassword = !showConfirmPassword))}
		>
			{#if !showConfirmPassword}
				<img
					class="absolute right-2 top-[40px] z-[10] cursor-pointer"
					src="/icons/eye.svg"
					alt="eye"
				/>
			{:else}
				<img
					class="absolute right-2 top-[40px] z-[1] cursor-pointer"
					src="/icons/eye-slash.svg"
					alt="eye"
				/>
			{/if}
		</button>
	{:else}
		<input
			class="border-[#DDD] w-full relative z-[0] pr-8 focus:outline-none focus:border-affair mb-2 {felteErrorMsg
				? '!border-red'
				: ''}"
			class:bg-gallery={disabled}
			{disabled}
			style={isInvalide}
			bind:value
			on:input={handleChange}
			id={label}
			type="text"
			{placeholder}
			{autocomplete}
		/>
	{/if}

	{#if felteErrorMsg}
		<div class="text-sm text-red -mt-2 mb-2">{felteErrorMsg}</div>
	{/if}
</div>
